module.exports = __webpack_public_path__ + "static/media/YourCity-es.feeee55f.jpg";